const downloadCsv = (downloadUrl: string, fileName: string) => {
    fetch(downloadUrl).then(response => {
        response.blob().then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            const disposition = response.headers.get("content-disposition");
            let filename = fileName;
            if (disposition && disposition.indexOf("filename=") !== -1) {

                /*
                
                Example of data:

                attachment; filename=content.txt
                attachment; filename*=UTF-8''filename.txt
                attachment; filename="EURO rates"; filename*=utf-8''%e2%82%ac%20rates
                attachment; filename="omáèka.jpg"

                regex explanation:
                
                filename      # match filename, followed by
                [^;=\n]*      # anything but a ;, a = or a newline
                =
                (             # first capturing group
                    (['"])    # either single or double quote, put it in capturing group 2
                    .*?       # anything up until the first...
                    \2        # matching quote (single if we found single, double if we find double)
                |             # OR
                    [^;\n]*   # anything but a ; or a newline
                )

                source:
                https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header
                
                */

                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    });
};

export default downloadCsv;
